import React, { Component } from 'react'
import { Button } from 'antd'
import qrCode from '../../images/wallet/qrcode.jpeg'

export default class Step2 extends Component {
    render() {
        return (
            <>
                <h3 className='tx-blue font-weight-bold'>Realize o pagamento</h3>
                <small className="float-right" style={{opacity: .7, cursor: 'pointer', paddingRight: '20px'}} onClick={this.props.goBack}>EDITAR</small><br />
                <div className='d-flex align-items-start mt-2 step1Token'>
                    <div className='w-50 pr-2'>
                        <label className='font-weight-bold'>Enviando para o endereço Solana</label><br />
                        <label style={{wordBreak: 'break-all'}}>{this.props.enderecoSolana}</label>
                    </div>
                    <div className='totalToken d-flex flex-column justify-content-center align-items-center'>
                        <div className='w-100 d-flex justify-content-between'><span className='font-weight-bold'>Você vai receber</span> <span>{this.props.qt} FLWT</span></div>
                        <div className='d-flex justify-content-between w-100 mt-2'><span className='font-weight-bold tx-pink'>Total a pagar</span> <span>R${this.props.qt * 500},00</span></div>
                    </div>
                </div>
                <br />
                <div className="saldoWrapper d-flex w-80 justify-content-center align-items-center mt-3">
                    <div>
                        <label className='tx-pink font-weight-bold'>Transferir o valor para Flow.in</label>
                        <label>Chave PIX: 43707315000186</label>
                    </div>
                    <img src={qrCode} style={{width: '90px'}} />
                </div>
                <label className='font-weight-bold text-center mt-5 w-100 mb-0'>Já realizou o pagamento/PIX?<br />Clique no botão abaixo para confirmar</label>
                {this.props.message !== '' && <label className='tokenError'>{this.props.message}</label>}
                {!this.props.isSubmit ?
                    <center><Button onClick={() => this.props.onSubmit(this.props.enderecoSolana, this.props.qt, this.props.userid)} className="btnGrafico">Pagamento realizado</Button></center>
                : <center><Button disabled={true} className="btnGraficoDisabled">Confirmando Tokens</Button></center> }
            </>
        )
    }
}